import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard } from '../finance/shared';

const LoanSimulator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [amount, setAmount] = useState('10.000,00');
  const [rate, setRate] = useState('2,00');
  const [months, setMonths] = useState('12');
  const [type, setType] = useState('price');
  const [result, setResult] = useState<any>(null);

  const calculate = () => {
    const principal = parseFloat(parseBrazilianNumber(amount)) || 0;
    const monthlyRate = parseFloat(parseBrazilianNumber(rate)) / 100;
    const n = parseInt(months) || 0;
    if (principal <= 0 || monthlyRate < 0 || n <= 0) return;

    let monthlyPayment, totalInterest;
    if (type === 'price') {
      monthlyPayment = principal * (monthlyRate * Math.pow(1 + monthlyRate, n)) / (Math.pow(1 + monthlyRate, n) - 1);
      totalInterest = (monthlyPayment * n) - principal;
    } else {
      const principalPayment = principal / n;
      monthlyPayment = principalPayment + (principal * monthlyRate); // 1ª parcela
      totalInterest = principal * monthlyRate * ((n + 1) / 2);
    }

    const totalPaid = principal + totalInterest;
    setResult({ monthlyPayment, totalInterest, totalPaid });
    onResultChange([
      { label: 'Valor Financiado', value: `R$ ${principal.toLocaleString('pt-BR')}` },
      { label: 'Total de Juros', value: `R$ ${totalInterest.toLocaleString('pt-BR')}` },
      { label: 'Total a Pagar', value: `R$ ${totalPaid.toLocaleString('pt-BR')}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <FormField label="Valor (R$)" value={amount} onChange={setAmount} isNumeric required type="text" />
          <FormField label="Taxa (% a.m.)" value={rate} onChange={setRate} isNumeric required type="text" />
          <FormField label="Meses" value={months} onChange={setMonths} isNumeric required type="text" />
          <FormField label="Sistema" value={type} onChange={setType} type="select" options={[{ value: 'price', label: 'Price' }, { value: 'sac', label: 'SAC' }]} />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:scale-105 transition-all">Simular</button>
        </div>
        {result && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Parcela (1ª)" value={`R$ ${result.monthlyPayment.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
            <ResultCard title="Total Juros" value={`R$ ${result.totalInterest.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="amber" />
            <ResultCard title="Total Pago" value={`R$ ${result.totalPaid.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="rose" />
          </div>
        )}
      </div>
    </div>
  );
};

export default LoanSimulator;
